import React, {useEffect} from 'react'
import './about.css';
import {Helmet} from "react-helmet";
import ChangeLang from '../changeLang/changeLang';

function About() {
	useEffect(() => {
		// Target when contents is on screen, and then fade in animation
		let contents = document.getElementsByClassName('contentAbout');
		const observerContents = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0) {
					entry.target.classList.add('fadeIn');
				} else {
					entry.target.classList.remove('fadeIn');
				}
			})
		})
		for (let content of contents) {
			observerContents.observe(content);
		}

		// Target when cards is on screen in 1/3 while enter from top or 2/3 whil eneter from bottom, and then fade in zoom
		let cards = document.getElementsByClassName('flip-card-inner');
		const observerCards = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0.33 && entry.intersectionRatio < 0.66) {		
					entry.target.classList.add('visible');
				} 
				if (entry.intersectionRatio === 0) {
					entry.target.classList.remove('visible');
				}
			})
		}, {
			threshold: [0, .33, .66, 1]
		  })
		for (let card of cards) {
			observerCards.observe(card);
		}

		return () => {
			observerContents.disconnect();
			observerCards.disconnect();
		}
	}, [])

// If it is an English page, so render it in english
if (window.location.href.includes('/en')) {
	return (
		<div id="about">
			<ChangeLang/>

			<Helmet>
				<html lang="en" />
				<title>About Us | Itay's Restaurant</title>
				<meta 
				name="description" 
				content="All the history of Itay's Restaurant (© Itay Shiff) in one place, how it started and how it has become what it is today." />
			</Helmet>

			

			<div id="aboutBackground" className="backgroundAbout" alt="restaurant background about me">
				
				<div className="contentAbout">
					<div className="titlePage">About Us</div>
					<p><b>Itay's Restaurant</b> was born out of an idea of 3 young people who used to dine at The Lakeside Brewery (in 1963).</p>
					<p>Itay's restaurant has been their favorite place since.</p>
					<p>They used to go there every single day of the week, meet each other, eat great food and share their life, this is how they became the best friends.</p>
				</div>
			</div>
			

			<div id="friendsWrapper">
				<h2>Our Core Team</h2>
				<div id="Friends3">
					
					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>Itay Shiff</h1> 
							<p>Creator of this website</p> 
							<p>Our CEO</p>
						</div>
					</div>
					</div>

					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>Itay Shiff</h1> 
							<p>Creator of this website</p> 
							<p>Our Founder</p>
						</div>
					</div>
					</div>

					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>Itay Shiff</h1> 
							<p>Creator of this website</p> 
							<p>Our President</p>
						</div>
					</div>
					</div>
				</div>
			</div>


			<div id="aboutBackground2" className="backgroundAbout" alt="restaurant background about me3">
				<div className="contentAbout">
				<p>One day the restaurant went bankrupt. It was devastating for those 3 friends, they wanted so badly to save The Lakeside Brewery from falling, but they couldn't make it.</p>
				<p>After that awful day, they decided they want to re-create that place, and started saving money in order to <b>fulfill their dream.</b></p>
				<p>Once they earned enough money, <b>in 1974</b>, they finally created this restaurant and they decided to call it - <b>Itay's Restaurant</b>, which is named after the creator of The Lakeside Brewery.</p>
				<p>And this is how it all began.. 😊</p>
				</div>
			</div>
		</div>	
	)
}

	// Else render it in hebrew
	return (
		<div id="about" className="hebrew">
			<ChangeLang/>

			<Helmet>
				<title>עלינו | המסעדה של איתי</title>
				<meta 
				name="description" 
				content="כל ההיסטוריה של המסעדה של איתי (איתי שיף ©), איך הכל התחיל ואיך הפכנו להיות מה שאנחנו היום." />
			</Helmet>

			

			<div id="aboutBackground" className="backgroundAbout" alt="restaurant background about me">
				
				<div className="contentAbout">
					<div className="titlePage">עלינו</div>
					<p><b>המסעדה של איתי</b>  נולדה מתוך רעיון של 3 אנשים שנהגו לסעוד במסעדת ה"לייקסייד ברוורי" באנגליה (בשנות ה60).</p>
					<p>המסעדה הזו הייתה המקום האהוב ביותר והמועדף עליהם להפגש בכל סופ"ש.</p>
					<p>הם נהגו ללכת לשם כל יום במהלך השבוע, להפגש אחד עם השני, לאכול אוכל טוב ולחלוק את חייהם, כך הם הפכו לחברים הטובים ביותר.</p>
				</div>
			</div>
			

			<div id="friendsWrapper">
				<h2>מי אנחנו ?</h2>
				<div id="Friends3">
					
					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>איתי שיף</h1> 
							<p>יוצר האתר</p> 
							<p>המנכ"ל שלנו</p>
						</div>
					</div>
					</div>

					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>איתי שיף</h1> 
							<p>יוצר האתר</p> 
							<p>המייסד שלנו</p>
						</div>
					</div>
					</div>

					<div className="flip-card">
					<div className="flip-card-inner">
						<div className="flip-card-front">
							<img src="/assets/about/itayshiff.jpg" alt="Avatar Itay Shiff"/>
							<img className="arrowUp" src="/assets/about/arrowUp.png" alt="arrowUp"/>
						</div>
						<div className="flip-card-back">
							<h1>איתי שיף</h1> 
							<p>יוצר האתר</p> 
							<p>הנשיא שלנו</p>
						</div>
					</div>
					</div>
				</div>
			</div>


			<div id="aboutBackground2" className="backgroundAbout" alt="restaurant background about me3">
				<div className="contentAbout">
				<p>יום אחד, מסעדת "לייקסייד ברוורי" פשטה את הרגל. שלושת החברים האלו היו מאוד עצובים, הם רצו כל כך להציל אותה מקריסה, אך לא היה זאת ביכולתם.</p>
				<p>בעקבות כך, אחרי היום הנורא ההוא, החליטו החברים שהם רוצים ליצור מחדש את המקום הקוסמי ההוא, והם התחילו לחסוך כסף כדי <b>להגשים את חלומם</b>.</p>
				<p>ברגע שהיה להם מספיק כסף, <b>בשנת 1974</b>, הם סוף סוף הקימו את המסעדה והחליטו לקרוא לה - <b>המסעדה של איתי</b>, שנקראה על שם המנהל של מסעדת ה"לייקסייד".</p>
				<p>וכך הכל התחיל.. 😊</p>
				</div>
			</div>
		</div>
	)
}

export default About